import { Component, OnInit, Input } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { TaggingService } from '../../services/tagging.service';
import { DataSharingService } from '../../services/data-sharing.service';
declare var $: any;

@Component({
    selector: 'tag-editing',
    templateUrl: './tag-editing.component.html',
    styleUrls: ['./tag-editing.component.css'],
    standalone: false
})
export class TagEditingComponent implements OnInit {
  emailOnAccount: string;
  isSuperUser: boolean;

  hasUserTags: boolean = true;
  hasOrganisationTags: boolean = true;

  constructor(
    private communicationService: CommunicationService,
    private taggingService: TaggingService,
    private data: DataSharingService
  ) {}

  isLoading = this.taggingService.isLoading;

  @Input()
  inputParams: any = {
    inputTags: [],
    tagTypeString: '',
    organisationUsers: [],
    organisationTeams: [],
  };

  ngOnInit() {
    this.communicationService.getIsSuperUserMessage().subscribe(isSuperUser => {
      this.isSuperUser = isSuperUser;
    });
    this.communicationService.getEmailMessage().subscribe(accountEmail => {
      this.emailOnAccount = accountEmail;
    });

    // This waits up to 15 seconds to ensure the tags have been pulled before updating the status hasOrganisationTags
    // and hasUserTags
    var numberOfLoops = 0;
    var checkingIntervalToSeeIfTagsUpdated = setInterval(() => {
      if (
        (this.inputParams.inputTags && this.inputParams.inputTags.length) ||
        numberOfLoops >= 15
      ) {
        this.updateTypeOfTagNumbers();
        clearInterval(checkingIntervalToSeeIfTagsUpdated);
      }
      numberOfLoops = numberOfLoops + 1;
    }, 1000);
  }

  updateTypeOfTagNumbers(): void {
    if (this.inputParams.inputTags != undefined) {
      this.hasOrganisationTags =
        this.inputParams.inputTags.filter(tag => tag.isOrgTag == true).length >
        0;
      this.hasUserTags =
        this.inputParams.inputTags.filter(tag => tag.isOrgTag == false).length >
        0;
    }
  }

  updateTagDetailsAfterChange(data): void {
    this.inputParams.inputTags
      .filter(tag => tag.id == data.updated_tag.id)
      .map(tag => (tag.view_users = data.updated_tag.view_users));
    this.inputParams.inputTags
      .filter(tag => tag.id == data.updated_tag.id)
      .map(tag => (tag.edit_users = data.updated_tag.edit_users));
    this.inputParams.inputTags
      .filter(tag => tag.id == data.updated_tag.id)
      .map(tag => (tag.view_teams = data.updated_tag.view_teams));
    this.inputParams.inputTags
      .filter(tag => tag.id == data.updated_tag.id)
      .map(tag => (tag.edit_teams = data.updated_tag.edit_teams));
    this.updateTypeOfTagNumbers();
  }

  handlePermissionsChange(
    event: any,
    tagId: number,
    permissionType: 'view' | 'edit'
  ) {
    const { userId, id: teamId, selected } = event;

    let userOrTeam: 'User' | 'Team';
    if ('userId' in event && 'email' in event) {
      userOrTeam = 'User';
    }
    if ('id' in event && 'name' in event) {
      userOrTeam = 'Team';
    }

    if (permissionType === 'view') {
      const serviceMethod = selected
        ? `addViewable${userOrTeam}ToTag`
        : `removeViewable${userOrTeam}FromTag`;

      this.taggingService[serviceMethod](userId || teamId, tagId).subscribe(
        data => this.updateTagDetailsAfterChange(data)
      );
    }

    if (permissionType === 'edit') {
      const serviceMethod = selected
        ? `addEditable${userOrTeam}ToTag`
        : `removeEditable${userOrTeam}FromTag`;

      this.taggingService[serviceMethod](userId || teamId, tagId).subscribe(
        data => this.updateTagDetailsAfterChange(data)
      );
    }
  }

  triggerDeleteTag(tagID): void {
    this.data.changeDataSourceTagIdToDelete(tagID);
  }
}
